import { appsignal } from "./appsignal";

const SITE_KEY = "6LfhawksAAAAAKi6_eY3QReiohY3rSnlTWmMJ0tO";
const SCRIPT_ID = "google-recaptcha-v3";

// This script used to live in the :auth layout. That layout is rendered by
// LiveView, so reaching /register through live navigation (/sign-in or a public
// profile) patched the <script> tag in via morphdom, which never executes it --
// leaving `grecaptcha` undefined and the submit button dead. A script element
// created here always executes, however the page was reached.
let loader = null;

function loadRecaptcha() {
    if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
    if (loader) return loader;

    loader = new Promise((resolve, reject) => {
        const existing = document.getElementById(SCRIPT_ID);
        const script = existing || document.createElement("script");

        script.addEventListener("load", () => resolve(window.grecaptcha));
        script.addEventListener("error", () => {
            loader = null;
            script.remove();
            reject(new Error("Failed to load the Google reCAPTCHA script"));
        });

        if (!existing) {
            script.id = SCRIPT_ID;
            script.async = true;
            script.defer = true;
            script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
            document.head.appendChild(script);
        }
    });

    return loader;
}

function executeRecaptcha(grecaptcha) {
    return new Promise((resolve, reject) => {
        grecaptcha.ready(() => grecaptcha.execute(SITE_KEY, { action: "submit" }).then(resolve, reject));
    });
}

export default CaptchaHook = {
    mounted() {
        // Start fetching as soon as the button renders so a token is ready by
        // the time the user submits.
        loadRecaptcha().catch((error) => appsignal.sendError(error));

        this.el.addEventListener("click", async (event) => {
            event.preventDefault();

            try {
                this.submitWith(await executeRecaptcha(await loadRecaptcha()));
            } catch (error) {
                console.error("reCAPTCHA error:", error);
                appsignal.sendError(error);
                // Submit without a token so the server can reject it and show a
                // retry message, rather than leaving the button unresponsive.
                this.submitWith("");
            }
        });
    },

    submitWith(token) {
        const field = document.getElementById("g-recaptcha-response");
        const form = document.getElementById("register-form");

        if (field) field.value = token;
        if (form) form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    },
};
